/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Description_PlaceholderInputs */

const en_admin_posts_description_placeholder = /** @type {(inputs: Admin_Posts_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brief description`)
};

/**
* | output |
* | --- |
* | "Brief description" |
*
* @param {Admin_Posts_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_posts_description_placeholder = /** @type {((inputs?: Admin_Posts_Description_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Description_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_posts_description_placeholder(inputs)
});
export { admin_posts_description_placeholder as "admin.posts.description_placeholder" }